// extracted by mini-css-extract-plugin
export default {"table":"InfoBox_table__17Ajw"};